export default "__VITE_ASSET__DpAiTW3d__"